import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description: string;
  image?: string;
  url?: string;
  type?: string;
}

const SEO: React.FC<SEOProps> = ({ 
  title, 
  description, 
  image = '/ChatGPT_Image_Sep_20,_2026,_07_14_20_PM.png',
  url = 'https://mondaynightgroup.com',
  type = 'website'
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Basic meta tags */}
      <meta name="author" content="Monday Night Group" />
      <meta name="keywords" content="men's group, bible study, fellowship, Nashville, community, faith, discipleship" />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={title} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Monday Night Group" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:image:alt" content={title} />
      <meta name="twitter:site" content="@mondaynightgroup" />
      <meta name="twitter:creator" content="@mondaynightgroup" />

      {/* Apple-specific meta tags for iOS */}
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="apple-mobile-web-app-title" content="Monday Night Group" />
      <meta name="apple-touch-fullscreen" content="yes" />
      
      {/* iOS Safari specific */}
      <meta name="format-detection" content="telephone=no" />
      <meta name="msapplication-TileColor" content="#2563eb" />
      <meta name="theme-color" content="#2563eb" />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": type === 'article' ? 'Article' : 'Organization',
          "name": "Monday Night Group",
          "url": "https://mondaynightgroup.com",
          "logo": {
            "@type": "ImageObject",
            "url": "https://mondaynightgroup.com/ChatGPT_Image_Sep_20,_2026,_07_14_20_PM.png"
          },
          "description": description,
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Nashville",
            "addressRegion": "TN",
            "addressCountry": "US"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer service",
            "url": "https://mondaynightgroup.com/#contact"
          }
        })}
      </script>
    </Helmet>
  );
};

export { SEO };